// External Imports
import { useState } from "react";
import Modal from "../UI/Modal";
import Heading from "../UI/Heading";
import { MdClose, MdDeleteOutline } from "react-icons/md";
import DetailPair from "../UI/DetailPair";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import { requestAdminAPI } from "../../api/posh-api";
import { differenceInMonths } from "date-fns";
import SelectPair from "../UI/SelectPair";

/** ========================================================================
 * * EditService Component
 * This component renders a form to edit a service.
 * ========================================================================== */

export default function EditService({ open, setOpen, service, onComplete }) {
  const [loading, setLoading] = useState(false);

  /* ====================== EDIT SERVICE ====================== */
  const submitHandler = async () => {
    try {
      setLoading(true);
      const payload = {
        serviceId: service.id,
        toDelete: false,
        status: document.getElementById("status").value,
      };

      const response = await requestAdminAPI("edit-service", payload);
      setOpen(false);
      onComplete && onComplete();
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  /* ====================== DELETE SERVICE ====================== */
  const deleteHandler = async () => {
    try {
      setLoading(true);
      const payload = {
        serviceId: service.id,
        toDelete: true,
      };

      const response = await requestAdminAPI("edit-service", payload);
      setOpen(false);
      onComplete && onComplete();
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal lg:w-[45vw] gap-6">
        <Heading title="Add Service" isBackArrow={false}>
          <MdDeleteOutline className="icon" onClick={deleteHandler} />
          <MdClose className="icon" onClick={() => setOpen(false)} />
        </Heading>
        <div className="info">
          <div className="lg:col-span-2">
            <DetailPair
              label="Vehicle"
              value={`${service?.vehicle?.year} ${service?.vehicle?.make.name} ${service?.vehicle?.model}`}
            />
          </div>
          <DetailPair label="Interval Miles" value={service?.intervalMiles} />
          <DetailPair
            label="Interval Months"
            value={
              service?.dueDate &&
              differenceInMonths(new Date(service.dueDate), new Date())
            }
          />
          <SelectPair
            options={["active", "paused"]}
            edit={true}
            label="Status"
            inputOptions={{
              defaultValue: service?.status,
            }}
          />
          <div className="lg:col-span-3">
            <DetailPair label="Description" value={service?.description} />
          </div>
        </div>
        {loading ? (
          <LoadingSpinnerWrapper />
        ) : (
          <div className="grid gap-4 text-sm lg:grid-cols-2">
            <div className="btn-secondary" onClick={() => setOpen(false)}>
              Cancel
            </div>
            <div className="btn-primary" onClick={submitHandler}>
              Submit
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}
